<template>

    <ICountUp
      :startVal="startVal"
      :endVal="endVal"
      :decimals="decimals"
      :duration="duration"
      :options="options"
      @ready="onReady"
    />

</template>

<script type="text/babel">
  import ICountUp from 'vue-countup-v2';
  export default
  {
    name: 'app-count-up',
    components: {
      ICountUp
    },
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        isActive: {
            type: Boolean,
            default: !1
        },
       delays: {
            type: Number,
            default: 0
        },
        endValS: {
            type: Number,
            default: 0
        },
        startValS: {
            type: Number,
            default: 0
        }
    },
    watch:
    {
        isActive: "onActiveChange"
    },
    data() {
      return {
        startVal: 0,
        endVal: 0,
        decimals: 0,
        duration: 2.5+this.delays,
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: '+'
        }
      };
    },
    methods: {
      onActiveChange: function() {
        this.startVal=this.startValS
        this.endVal=this.endValS

      },
      onReady: function(instance, CountUp) {
        //const that = this;
        //instance.update(that.endVal + 100);
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/app-countup/index.vue